import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import CheckItem, { ICON_ALERT } from 'Components/CheckItem/CheckItem'
import { EmailMessageCheckUpIssueType } from 'Constants/'
import DynamicFieldCheck from 'Components/ModalCheckup/components/DynamicFieldCheck/DynamicFieldCheck'
import PropTypes from 'prop-types'
import { modalCheckupState } from 'Components/ModalCheckup/recoil/state'

const PotentialCheck = ({ messageType, isBee, idMessage, idCampaign }) => {
  const intl = useIntl()

  const {
    dynamicFieldsOptionEnabled,
    wrongDynamicTags,
    checkLinksWoTracking,
    checkUnsubscribeLink,
    checkMaxSize,
    checkBlacklistResult,
    checkWorkflowWarning,
    silencedAlertsArray
  } = useRecoilValue(modalCheckupState)

  const props = () => ({
    icon: ICON_ALERT,
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.WarningLabel'
    })
  })

  return (
    <div className='c-potential-issue'>
      {(dynamicFieldsOptionEnabled ||
        (wrongDynamicTags && wrongDynamicTags.length > 0)) &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.DynamicFieldsWarning
        ).silenced && (
          <>
            <DynamicFieldCheck
              messageType={messageType}
              isBee={isBee}
              idMessage={idMessage}
              idCampaign={idCampaign}
            />
          </>
        )}

      {!checkLinksWoTracking &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.LinkTrackingWarning
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.LinkTrackingWarning'
            })}
          />
        )}

      {!checkMaxSize.Check &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.MaxSizeInfo
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.MaxSizeInfo'
            })}
            description={
              <span>
                {intl.formatMessage(
                  {
                    id: 'Load.EmailCheckUp.MaxSizeWarningDescrModal'
                  },
                  {
                    size: intl.formatNumber(
                      checkMaxSize.Size + checkMaxSize.OverMaximumSize,
                      {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                      }
                    ),
                    maxsize: intl.formatNumber(checkMaxSize.Size, {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    })
                  }
                )}
              </span>
            }
          />
        )}

      {!checkUnsubscribeLink &&
        !silencedAlertsArray.find(
          e =>
            e.issueType === EmailMessageCheckUpIssueType.UnsubscribeLinkWarning
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.UnsubscribeLinkWarning'
            })}
          />
        )}

      {checkBlacklistResult.Action === 1 &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.BlackListUrlWarning
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.BlackListUrlWarning'
            })}
          />
        )}

      {checkWorkflowWarning &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.WorkflowWarning
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.WorkflowWarning'
            })}
          />
        )}
    </div>
  )
}

PotentialCheck.propTypes = {
  idMessage: PropTypes.number,
  messageType: PropTypes.any,
  isBee: PropTypes.bool,
  idCampaign: PropTypes.number
}

export default PotentialCheck
